/**
 * Web Style Import
 *
 */

import './style/dnb-avatar.scss'
